import { Box, Checkbox } from '@material-ui/core';
import { SinglePaymentMethod } from '@nemuru-eng/js-api-client';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { A2APaymentProviderOptions } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/A2APaymentProviderOptions';
import { CardPaymentProviderOptions } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/CardPaymentProviderOptions';
import { SinglePaymentMethodOptions } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/SinglePaymentMethodOptions';
import { Font } from '@/components/shared/components/Font';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

export const AddOrEditAgentInSinglePaymentProviderContextForm = () => {
  const { getTextIdTranslation: t } = useTranslation();
  const { setValue, watch, getValues, clearErrors, reset } = useFormContext();
  const hasConfiguration = getValues('productId');
  const configuration = watch('configuration', false);
  const paymentMethodType = watch('paymentMethodType');

  useEffect(() => {
    if (hasConfiguration) {
      setValue('configuration', true);
    }
  }, [hasConfiguration, setValue]);

  useEffect(() => {
    if (!configuration) {
      reset({
        productId: undefined,
        merchantId: undefined,
        merchantKey: undefined,
        merchantPassword: undefined,
      });
    }
  }, [configuration]);
  return (
    <Box pt={2}>
      <FormGridContainer fieldVariant={FieldVariant.form} fullWidth>
        <SelectFormField
          name={'paymentMethodType'}
          label={'PAYMENT_METHOD'}
          selectOptions={SinglePaymentMethodOptions(t)}
        />
        <SelectFormField
          name={'providerId'}
          label={'PROVIDER_ID'}
          selectOptions={
            paymentMethodType === SinglePaymentMethod.CARD_PAYMENT
              ? CardPaymentProviderOptions(t)
              : A2APaymentProviderOptions(t)
          }
        />
        {configuration && <TextFormField name={'productId'} label="PRODUCT_ID" />}
        {configuration && <TextFormField name={'merchantId'} label="MERCHANT_ID" />}
        {configuration && <TextFormField name={'merchantKey'} label="MERCHANT_KEY" />}
        {configuration && <TextFormField name={'merchantPassword'} label="MERCHANT_PASSWORD" />}
      </FormGridContainer>
      <Box pt={1} display={'inline-flex'} alignItems={'center'}>
        <Checkbox
          checked={configuration}
          name={'configuration'}
          onChange={() => {
            setValue('configuration', !configuration);
            clearErrors();
          }}
          style={{ marginLeft: '-12px' }}
        />
        <Font variant={'body2'} color={'textSecondary'}>
          <Text tId={'SET_AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT_CONFIGURATION'} />
        </Font>
      </Box>
    </Box>
  );
};
